export const D365_BUNDLE_URL =
  'https://formui-usa1.mkt.dynamics.com/eur/FormCapture/FormCapture.bundle.js'

export const D365_FORM_API_URL =
  'https://public-eur.mkt.dynamics.com/api/v1.0/orgs/cbce02d5-bc93-f011-a700-000d3a65ce58/landingpageforms'

export const CRM_FIXED_MAPPINGS = [
  {
    DataverseFieldName: 'wp_sectorid',
    DataverseFieldValue:
      '{"Id":"710f4429-ad6b-f011-b4cc-000d3ab483e3","LogicalName":"wp_sector"}',
  },
  {
    DataverseFieldName: 'wp_channeltypeid',
    DataverseFieldValue:
      '{"Id":"1ab713e9-d30c-f111-8406-6045bdde1a47","LogicalName":"wp_channeltype"}',
  },
]

export const CRM_CONSENT_MAPPING = {
  FormFieldName: 'privacy',
  DataverseFieldName: 'msdynmkt_purposeid;channels;optinwhenchecked',
  DataverseFieldValue:
    'b94cbe05-5406-f111-8407-002248a22676;Email,Text;true',
}
